import React from 'react';

interface WarningModalProps {
  open: boolean;
  handleClose: () => void;
}

const WarningModal: React.FC<WarningModalProps> = ({ open, handleClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="relative bg-[#D9D9D9] w-[1040px] max-w-[calc(100%-2rem)] h-[575px] max-h-[90vh] rounded-3xl shadow-lg overflow-x-hidden overflow-y-hidden font-sans flex flex-col items-center">
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 text-[#737373] hover:text-gray-600 p-2 z-10"
          aria-label="Cerrar aviso"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="flex items-center justify-center gap-2 w-[760px] max-w-[calc(100%-4rem)] min-h-[44px] mt-10 shrink-0 px-2">
          <img
            src="/static/warning_icon.png"
            alt="Advertencia"
            className="w-6 h-6 shrink-0"
          />
          <h2 className="text-[24px] font-bold leading-tight text-center uppercase min-w-0">
            AVISO IMPORTANTE SOBRE PREVENCIÓN DE FRAUDES
          </h2>
        </div>

        <div className="w-[882px] max-w-[calc(100%-4rem)] h-[400px] max-h-[calc(90vh-10rem)] mt-12 overflow-x-hidden overflow-y-hidden max-sm:overflow-y-auto text-[12px] leading-[18px] text-justify font-normal break-words space-y-4">
          <p>
            <span className="font-bold">PITIC CAPITAL, S.A.P.I. de C.V., SOFOM, E.N.R.</span>{' '}
            informa al público en general que nuestra atención se brinda exclusivamente de manera personalizada en nuestras oficinas o a través de nuestros canales oficiales.
          </p>

          <p>
            <span className="font-bold">Manténgase alerta:</span> Hemos detectado el uso de{' '}
            <span className="font-bold">sitios web fantasma (páginas falsas),</span>{' '}
            así como correos electrónicos, llamadas y mensajes de texto que usurpan nuestro nombre e imagen corporativa para ofrecer financiamientos fraudulentos.
          </p>

          <p>Para su seguridad, le recordamos nuestras políticas operativas:</p>

          <ul className="list-disc ml-5 space-y-2 text-left w-full">
            <li>
              <span className="font-bold">NUNCA solicitamos anticipos,</span>{' '}
              depósitos, transferencias, ni pagos de ningún tipo para &quot;autorizar&quot;, &quot;gestionar&quot; o &quot;liberar&quot; un crédito.
            </li>
            <li>
              NUNCA solicitamos información sensible o contraseñas fuera de nuestros procesos oficiales de originación.
            </li>
          </ul>

          <p className="font-bold">Nuestros ÚNICOS medios de contacto oficiales son:</p>
          <ul className="list-disc ml-5 space-y-2 text-left w-full">
            <li>Teléfono de servicio y whatsapp: 662 110 5031, 662 112 2119 y 662 357 5790</li>
            <li>Correo electrónico: atencionaclientes@piticcapital.com.mx</li>
          </ul>

          <p>
            PITIC CAPITAL no asume responsabilidad alguna por depósitos a terceros o la contratación de servicios realizados fuera de nuestros canales y sin nuestra debida autorización.{' '}
            Si detecta actividad sospechosa o ha sido víctima de fraude, le recomendamos denunciar inmediatamente ante la CONDUSEF en el Portal de Fraudes Financieros:{' '}
            <a
              href="https://phpapps.condusef.gob.mx/fraudes_financieros/index.php"
              target="_blank"
              rel="noopener noreferrer"
              className="text-inherit no-underline"
            >
              https://phpapps.condusef.gob.mx/fraudes_financieros/index.php
            </a>{' '}
            y notificarnos vía correo electrónico.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
